import { IAnalysisItem } from "./IAnalysisItem";
import { IGCPBigQueryJob } from "./IGCPBigQueryJob";

export interface IProcessJobsResult {
    jobs: IGCPBigQueryJob[];
    mappedJobs: IAnalysisItem[];
    finishedInsights: string[];
}
